module.exports = __webpack_public_path__ + "img/garlands.2c0d57a3.png";